function throttle(fn, wait = 300) {
  let throttleTimeoutId = -1;
  let tick = false;

  return () => {
    clearTimeout(throttleTimeoutId);
    throttleTimeoutId = setTimeout(fn, wait);

    if (!tick) {
      fn.call();
      tick = true;
      setTimeout(() => {
        tick = false;
      }, wait);
    }
  };
}

if (!customElements.get('sticky-atc')) {
  customElements.whenDefined('product-form').then(() => {
    class StickyAtc extends customElements.get('product-form') {
      constructor() {
        super();
        if (!this.isConnected || !this.firstElementChild) {
          if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => { if (this.isConnected) this.initStickyAtc(); }, { once: true });
          }
          return;
        }
        this.initStickyAtc();
      }

      initStickyAtc() {

        this.section = this.closest('.section-main-product');
        this.mainProductForm = this.section.querySelector('.js-product');
        this.buyButtons = this.section.querySelector('buy-buttons');
        this.imageContainer = this.querySelector('.sticky-atc__image');
        this.variantContainer = this.querySelector('.sticky-atc__details__variant');
        this.variantTitle = this.querySelector('.sticky-atc__details__variant__title');
        this.variantTitle?.toggleAttribute('hidden', !this.section.querySelector('variant-picker'));

        this.throttledOnScroll = throttle(StickyAtc.handleScroll.bind(this));
        window.addEventListener('scroll', this.throttledOnScroll);

        this.section.addEventListener('on:variant:change', this.onVariantChange.bind(this));
        this.section.addEventListener('on:media-gallery:change', this.updateImage.bind(this));

        this.updateImage();

        this.restoreChip = document.querySelector('.js-sticky-atc-restore');
        this.minimized = false;
        try {
          if (localStorage.getItem('sp-sticky-atc-minimized') === '1') {
            this.classList.add('sticky-atc--minimized');
            this.minimized = true;
          }
        } catch (e) {  }
        this.querySelector('.js-sticky-atc-min')?.addEventListener('click', () => this.minimize());
        this.restoreChip?.addEventListener('click', () => this.restore());
        this.updateRestoreChip();
      }

      minimize() {
        this.minimized = true;
        try { localStorage.setItem('sp-sticky-atc-minimized', '1'); } catch (e) {  }
        this.flyTo('chip', () => {
          this.classList.add('sticky-atc--minimized');
          this.updateRestoreChip();
        });
      }

      restore() {
        this.classList.remove('sticky-atc--minimized');
        this.minimized = false;
        try { localStorage.removeItem('sp-sticky-atc-minimized'); } catch (e) {  }
        this.updateRestoreChip();

        this.flyFrom('chip');
      }

      chipBox() {
        const bar = this.getBoundingClientRect();
        if (!bar.width) return null;
        let left = 20, bottom = 20, w = 50, h = 50, r = 25;
        if (this.restoreChip) {
          const cs = getComputedStyle(this.restoreChip);
          const n = (v, d) => (Number.isFinite(parseFloat(v)) ? parseFloat(v) : d);
          w = n(cs.width, w); h = n(cs.height, h); left = n(cs.left, left); bottom = n(cs.bottom, bottom);
          r = Math.min(n(cs.borderTopLeftRadius, r), h / 2);
        }
        const top = window.innerHeight - bottom - h;
        const radius = parseFloat(getComputedStyle(this).borderTopLeftRadius) || 0;
        return {
          clipFrom: `inset(0px 0px 0px 0px round ${radius}px)`,
          clipTo: `inset(${Math.max(0, bar.height - h)}px ${Math.max(0, bar.width - w)}px 0px 0px round ${r}px)`,
          moveTo: `${Math.round(left - bar.left)}px ${Math.round(top + h - bar.bottom)}px`,
        };
      }

      contentsForMorph() {
        return Array.from(this.querySelectorAll(':scope > *:not(.sticky-atc__jump), :scope > .sticky-atc__jump > *'));
      }

      cancelMorph() {
        (this.morphAnims || []).forEach((a) => a.cancel());
        this.morphAnims = [];
      }

      flyTo(_target, done) {
        const box = this.chipBox();
        if (!box || !this.animate || window.matchMedia('(prefers-reduced-motion: reduce)').matches) { done(); return; }
        this.cancelMorph();
        const DUR = 300;
        const EASE = 'cubic-bezier(0.32, 0.72, 0, 1)';
        const shell = this.animate([
          { clipPath: box.clipFrom, translate: '0px 0px', opacity: 1 },
          { clipPath: box.clipTo, translate: box.moveTo, opacity: 1, offset: 0.8 },
          { clipPath: box.clipTo, translate: box.moveTo, opacity: 0 }
        ], { duration: DUR, easing: EASE, fill: 'forwards' });
        const fades = this.contentsForMorph().map((el) => el.animate(
          [{ opacity: 1 }, { opacity: 0 }],
          { duration: DUR * 0.25, easing: 'cubic-bezier(0.4, 0, 1, 1)', fill: 'forwards' }
        ));
        this.morphAnims = [shell].concat(fades);
        this.updateRestoreChip();
        let finished = false;
        const finish = () => {
          if (finished) return;
          finished = true;
          done();
          this.cancelMorph();
        };
        shell.finished.then(finish, finish);
        setTimeout(finish, DUR + 200);
      }

      flyFrom(_target) {
        const box = this.chipBox();
        if (!box || !this.animate || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.cancelMorph();
        const DUR = 420;
        const EASE = 'cubic-bezier(0.32, 0.72, 0, 1)';
        const shell = this.animate([
          { clipPath: box.clipTo, translate: box.moveTo, opacity: 0 },
          { clipPath: box.clipTo, translate: box.moveTo, opacity: 1, offset: 0.12 },
          { clipPath: box.clipFrom, translate: '0px 0px', opacity: 1 }
        ], { duration: DUR, easing: EASE });
        const fades = this.contentsForMorph().map((el) => el.animate(
          [{ opacity: 0 }, { opacity: 0, offset: 0.45 }, { opacity: 1 }],
          { duration: DUR, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' }
        ));
        this.morphAnims = [shell].concat(fades);
        shell.finished.then(() => { this.morphAnims = []; }, () => {});
      }

      updateRestoreChip() {
        if (!this.restoreChip) return;
        const show = this.minimized && !!this.wouldShow;
        this.restoreChip.classList.toggle('sticky-atc-restore--visible', show);
        this.restoreChip.hidden = !show;
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.throttledOnScroll);
      }

      async handleSubmit(evt) {
        evt.preventDefault();

        const variantId = this.section.querySelector('product-form buy-buttons input[name="id"]').value;
        if (!variantId) {
          const target = this.section.querySelector('#product-info');
          if (target && target.offsetParent) {
            evt.preventDefault();
            theme.scrollToRevealElement(target);
          }
          return;
        }
        const customFormValid = this.mainProductForm.validate();
        if (!customFormValid || !this.mainProductForm.form.reportValidity()) {
          evt.preventDefault();
          if (!customFormValid) {
            theme.scrollToRevealElement(this.mainProductForm);
          } else {
            const input = Array.from(this.mainProductForm.form.elements).find(
              (el) => !el.checkValidity()
            );
            setTimeout(() => theme.scrollToRevealElement(input), 100);
          }
          return;
        }
        this.form.querySelectorAll('[data-copied]').forEach((el) => el.remove());
        const formData = new FormData(this.mainProductForm.form);
        for (const p of formData) {
          if (!this.form.querySelector(`[name="${p[0]}"]`)) {
            const input = document.createElement('input');
            input.name = p[0];
            input.value = p[1];
            input.hidden = true;
            input.setAttribute('data-copied', '');
            this.form.append(input);
          }
        }
        super.handleSubmit(evt);
      }

      otherCtaOnScreen() {
        const els = document.querySelectorAll('.sp-sc-pricing__cta, .sp-sc-hero2__cta, .sp-sc-kt__cta, [data-sp-sticky-yield]');
        const vh = window.innerHeight;
        for (const el of els) {
          if (this.contains(el)) continue;
          const r = el.getBoundingClientRect();
          if (r.height && r.bottom > 0 && r.top < vh) return true;
        }
        return false;
      }

      static handleScroll() {
        const topOffset = document.querySelector('.pageheader--sticky') ? document.querySelector('.section-header').offsetHeight : 0;
        const SHOW_AT = 0.55;
        const HIDE_BELOW = 0.45;
        const scrollable = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
        const progress = window.scrollY / scrollable;
        const wasShown = !this.classList.contains('sticky-atc--out');
        const deep = progress >= SHOW_AT || (wasShown && progress >= HIDE_BELOW);
        this.classList.toggle(
          'sticky-atc--out',
          this.buyButtons.getBoundingClientRect().bottom > topOffset || !deep || this.otherCtaOnScreen()
        );

        const footer = document.getElementById('pagefooter');
        document.body.classList.toggle(
          'scrolled-to-bottom',
          footer
            ? footer.getBoundingClientRect().top <= window.innerHeight - this.offsetHeight - 24
            : window.scrollY + window.innerHeight + 100 > document.body.scrollHeight
        );

        this.wouldShow = !this.classList.contains('sticky-atc--out')
          && !document.body.classList.contains('scrolled-to-bottom');
        this.updateRestoreChip?.();
      }

      onVariantChange(evt) {
        const idInput = this.form?.querySelector('[name="id"]');

        if (evt.detail.variant) {
          this.variantTitle.textContent = evt.detail.variant.title;
          this.variantContainer.hidden = false;
          if (idInput) idInput.value = evt.detail.variant.id;
        } else {
          this.variantContainer.hidden = true;
          this.variantTitle.textContent = '';
          if (idInput) idInput.value = '';
        }

        this.updateImage();
        this.updateAddToCartButton(evt.detail.variant);
        this.setErrorMsgState();
        requestAnimationFrame(() => this.syncPrice());
      }

      syncPrice() {
        const main = this.section.querySelector('.product-info .price__current, .product-price .price__current');
        const m = main && main.textContent.match(/[^\s\d.,]*\d[\d.,]*(?:\s?[A-Z]{3})?/);
        const text = m ? m[0] : '';
        if (!text) return;
        this.querySelectorAll('.sticky-atc__details__price, .sticky-atc__price-col__amount').forEach((el) => {
          if (el.textContent.trim() !== text) el.textContent = text;
        });
      }

      updateImage() {
        const mainImage = this.section.querySelector('.media-gallery .main-image .slider__item.is-active .product-media img');

        if (mainImage) {
          this.imageContainer.innerHTML = mainImage.outerHTML;
        } else {
          this.imageContainer.textContent = '';
        }
      }

      updateAddToCartButton(variant) {
        if (!this.submitBtn) return;

        const variantAvailable = variant && variant.available;
        const unavailableStr = variant
          ? theme.strings.noStock : this.submitBtn.dataset.unavailableText;

        this.submitBtn.textContent = variantAvailable
          ? this.submitBtn.dataset.addToCartText
          : unavailableStr;
      }
    }

    customElements.define('sticky-atc', StickyAtc);
  });
}
